import React, { useEffect, useState } from 'react';
import CountButton from '../../Components/CountButton/CountButton';
import { Button, Textarea } from '../../Components/StyledComponents';
import './WaitingSetting.scss';
import {cloneDeep} from 'lodash-es';
import Dropdown from '../../Components/Dropdown/Dropdown';

const statusList = {
    'Open' : '운영중',
    'Stop' : '임시 중단',
    'Close' : '영업 종료'
}

const WaitingStatus = ({ rstatus }) => {
    const [ status, setStatus ] = useState('Open')

    useEffect(() => {
        if(typeof rstatus !== 'undefined') setStatus(cloneDeep(rstatus))
    },[])

    return (
        <div className='point-rate'>
            <div className='row between'>
                <p className='modal-title'>운영 상태</p>
                <div className="inner-row">
                    <Dropdown
                        id={'status'}
                        options={[
                            {value : 'Open', key : '운영중'},
                            {value : 'Stop', key : '임시 중단'},
                            {value : 'Close', key : '영업 종료'},
                        ]}
                        width={326}
                        value={statusList[status]}
                        onItemClick={(val) => setStatus(val)}
                    />
                </div>
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default WaitingStatus;